import styled from '@emotion/styled'
import { container, link } from './platformLinkStyles'

const PlatformLink = styled.a`
  ${link};
  ${container};
`

export default PlatformLink



// WEBPACK FOOTER //
// ./src/routes/home/components/PlatformLink.js